/**
 * Erzeugt ein Array von 7 lokalen Date-Objekten beginnend ab cycleStart.
 * cycleStart ist "YYYY-MM-DD HH:MM:SS" (UTC) – nur das Datum wird verwendet.
 */
export function getDaysFromCycleStart(startIso: string): Date[] {
  const parts = startIso.split(/[\s\-T]/);
  const base = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
  return Array.from({ length: 7 }, (_, i) => {
    const d = new Date(base);
    d.setDate(d.getDate() + i);
    return d;
  });
}

/**
 * Prüft ob ein UTC-Datumstring (z.B. "2026-05-12 09:00:00") am selben
 * Kalendertag wie ein lokales Date-Objekt liegt.
 */
export function isSameLocalDay(utcString: string, localDate: Date): boolean {
  const d = new Date(utcString.replace(' ', 'T') + 'Z');
  return (
    d.getFullYear() === localDate.getFullYear() &&
    d.getMonth()    === localDate.getMonth() &&
    d.getDate()     === localDate.getDate()
  );
}

/**
 * Formatiert Sekunden als lesbare Zeitangabe ("1h30m", "45min").
 */
export function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  if (h > 0) return `${h}h${m > 0 ? m + 'm' : ''}`;
  return `${m}m`;
}

/**
 * Gibt true zurück wenn das übergebene Date-Objekt der heutige Tag ist.
 */
export function isToday(date: Date): boolean {
  const now = new Date();
  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth()    === now.getMonth() &&
    date.getDate()     === now.getDate()
  );
}

/**
 * Converts a UTC timestamp string ("YYYY-MM-DD HH:MM:SS") to a human-readable
 * local time string, e.g. "Monday 08:00 (Europe/Vienna)".
 */
export function utcToLocalLabel(utc: string): string {
  const d = new Date(utc.replace(' ', 'T') + 'Z');
  const day  = d.toLocaleDateString(undefined, { weekday: 'long' });
  const time = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
  const tz   = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return `${day} ${time} (${tz})`;
}
